export const FEATURES = {
  PURGE_CACHE: 'purge_cache',
  DEV_MODE: 'dev_mode',
  UNDER_ATTACK_MODE: 'under_attack_mode',
  ALWAYS_ONLINE: 'always_online',
};

export const ERROR_MODAL_STATUS = {
  GENERIC: 'GENERIC',
  PURGE_CACHE: 'PURGE_CACHE',
  BLOCKING_ERROR: 'BLOCKING_ERROR',
};

export const SUCCESS_MODAL_STATUS = {
  GENERIC: 'GENERIC',
  ADD_NEW_RULE: 'ADD_NEW_RULE',
  DELETE_RULE: 'DELETE_RULE',
};

export const CONFIRM_MODAL = {
  DELETE_RULE: 'DELETE_RULE',
};

export const TABS = {
  tools: 'tools',
  speed: 'speed',
  visitors: 'visitors',
  progressBar: 'progressBar',
  security: 'security',
};
